<template lang="html">
  <div class="timeline"
  :class="{
    'hide': scrollProgress==0
    }"
  >

    <div class="track-wrapper"
    :class="{
      'hide': scrollProgress==0
      }"
    >

      <div
      class="track-complete"
      >
        <div
        class="track-complete-stroke"
        >

        </div>
      </div>

      <div
      class="track-marking"
      ></div>

      <div
      class="track" style=""
      :style="getTrackStyle()"
      >
        <div class="track-cell"
        v-for="content in contents"
        :id="`track-cell-${content.id}`"
        :style="getTrackCellStyle(content)"
        :class="getTrackCellClass(content)"
        :key="content.id"
        >
          <div class="track-content" :id="`track-content-${content.id}`">
            <div class="marker" v-if="content.showMarker">
              {{content.id}}
            </div>
            <div class="title-intro">
              <div class="title" v-if="content.title">
                <VueShowdown :markdown="content.title"/>
              </div>
              <!-- <div class="intro" v-if="content.intro">
                <VueShowdown :markdown="content.intro"/>
              </div> -->
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="flickity-wrapper">
      <flickity class="flickity-track" id="flickity" ref="flickity" :options="flickityOptions" @init="onInit">
        <div class="flickity-cell" v-for="content in contents" :key="content.id" :id="`flickity-cell-${content.id}`">
        </div>
      </flickity>
    </div>

    <!-- <div class="fixed left-0 top-0 text-white z-50 mt-24" >
      progress: {{progress}}<br>
      scrollProgress: {{scrollProgress}}<br>
      sceneProgress: {{sceneProgress}}
    </div> -->

  </div>
</template>

<script>
// import marked from 'marked'
import {pythagorean} from '@/common/util.js'
import {contents} from '@/common/content.js'
import Flickity from 'vue-flickity';
import {gsap} from 'gsap'
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default {
  components: {
    Flickity
  },

  data() {
    return {
      progress: 0,
      velocity: 0,
      isDragging: false,
      hasAutoSnapped: false,
      coverageDegree: 270,
      total: Object.keys(contents).length,
      contents: contents,
      flickityOptions: {
        // initialIndex: 0,
        prevNextButtons: false,
        setGallerySize: false,
        pageDots: false,
        wrapAround: false,
        cellAlign: 'center',

        selectedAttraction: 0.015, //0.025
        friction: 0.2, //0.28
        // freeScroll: true,
        // freeScroll: false,
        // selectedAttraction: 0.01,
        // friction: 0.15
        // any options from Flickity can be used
      }
    }
  },

  computed: {
    scrollProgress () {
      return this.$store.state.scrollProgress
    },
    sceneProgress () {
      return this.$store.state.sceneProgress
    }
  },

  watch: {
    'scrollProgress' (newVal, oldVal) {
      this.onScrollProgressChange(newVal)
    },
    // 'sceneProgress' (newVal, oldVal) {
    //   // this.onSceneProgressChange(newVal)
    // }
  },

  methods: {

    // markdown (string) {
    //   return marked(string)
    // },
    onScrollProgressChange (newVal) {
      this.select(newVal)
    },

    onSceneProgressChange (newVal) {
      return
    },

    onInit () {
      this.$refs.flickity.on( 'scroll', this.onScroll);
      this.$refs.flickity.on( 'dragEnd', this.onDragEnd);
      this.$refs.flickity.on( 'dragStart', this.onDragStart);
      this.$refs.flickity.on( 'settle', this.onSettle);
      // this.$refs.flickity.on('dragMove', (event, pointer, moveVector) => {
      //   // this.$emit('change', event);
      //   console.log(event, pointer, moveVector)
      // });
    },

    onDragStart () {
      this.isDragging = true
      let fkty = this.$refs.flickity.$flickity
      // fkty.options.selectedAttraction = 0.015;
      // fkty.options.friction = 0.15;
    },

    onDragEnd (event, pointer) {
      // console.log('dragEnd')
      this.isDragging = false
      this.hasAutoSnapped = false
    },

    onSettle (event, pointer) {
      console.log('settle', event)
      let fkty = this.$refs.flickity.$flickity

      let contentIndex = Math.min(Math.max(0, event), 13);
      gsap.to(window, {
        duration: 1,
        ease: 'power4.out',
        scrollTo: {
          y:`#scroll-content-${contentIndex}`,
          offsetY: -200
        }
      });

      // fkty.options.selectedAttraction = 0.01;
      // fkty.options.friction = 0.1;
      // fkty.options.freeScroll = true
    },

    onScroll (progress) {
        // this.$emit('change', event);
        // progress = Math.max( 0, Math.min( 1, progress ) );
        // const pc = Math.round(progress*1000)/10 + '%'
        let fkty = this.$refs.flickity.$flickity

        this.progress = Math.round(progress*10000)/100
        this.velocity = Math.abs(Math.round(fkty.velocity*100)/100)
        // console.log('scroll. snapped?', this.hasAutoSnapped)
        // if (this.hasAutoSnapped) return;
        // let velocity = this.velocity
        // if (velocity < 0.5) {
        //   fkty.options.selectedAttraction=Math.min(Math.max(0.5-velocity,0.15), 0.5)/4;
        //   fkty.options.friction=Math.min(Math.max(0.5-velocity,0.15), 0.5);
        // }
        // let coverageDegree = this.coverageDegree
        // let total = this.total
        // let rotationSegment = coverageDegree/total

        // let velocity = Math.round(this.$refs.flickity.$flickity.velocity*100)/100
        // console.log(velocity)
        // if (velocity < 5) {
        //
        // }

        // let shift = 50
        // let fx = Math.round(this.$refs.flickity.$flickity.x) + shift
        // let r = window.innerWidth/2

        // gsap.to('.track', {
        //   duration: 0.1,
        //   ease: 'power0.linear',
        //   rotate: -progress * coverageDegree
        // })

        // for (let i = 0; i < this.$refs.flickity.$flickity.cells.length; i++) {
        //   let cell = this.$refs.flickity.$flickity.cells[i]
        //   let cellx = cell.x
        //
        //   let x = cellx
        //   let newY = r-pythagorean(x-fx,r)
        //   // console.log(newY)
        //   // gsap.set(`#track-content-${i+1}`, {
        //   //   y: newY
        //   //   // rotate: `${Math.round(-progress*1000)/10}deg`
        //   // })
        // }
    },

    select (index) {
      if (index<0) return;
      this.$refs.flickity.select(index);
    },

    next() {
      this.$refs.flickity.next();
    },

    previous() {
      this.$refs.flickity.previous();
    },

    getTrackStyle() {
      // let degree = `${this.process}deg`
      let coverageDegree = this.coverageDegree
      let progress = this.progress/100
      let degree = `${-progress * coverageDegree}deg`
      return {
        'transform': `rotate(${degree})`
      }
    },

    getTrackCellStyle (cell) {
      let coverageDegree = this.coverageDegree
      let total = this.total-1
      let degree = `${(cell.position) * coverageDegree/total}deg`
      return {
        'transform': `rotate(${degree})`
      }
    },

    getTrackCellClass (cell) {
      let coverageDegree = this.coverageDegree
      let progress = this.progress/100
      let dialDegree = progress * coverageDegree
      let total = this.total-1
      let degree = (cell.position) * coverageDegree/total
      return {
        'active': dialDegree+1>degree,
        'active-snap': Math.abs(dialDegree-degree)<1
      }
    },

    // setLoadProgress (progress) {
    //   console.log('on progress', progress)
    //   this.$store.commit('setLoadingProgress', { progress: progress })
    //   // this.$store.commit('setStage', { stage: 'LOADED' })
    // },
  }
}
</script>

<style lang="scss">
.timeline {
  @apply fixed pointer-events-auto bottom-0 inset-x-0 z-10;
  // @apply bg-red-400;
  height: 200px;
  height: 15vmax;
  height: 20vmax;
  @screen md {
    height: 10vmax;
  }

  @apply transition duration-700 ease-in-out;
  background-image: linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0));
  &:not(.hide) {
    background-image: linear-gradient(rgba(0,0,0,0), rgba(0,0,0,1));
  }
}

.track-wrapper {
  @apply absolute pointer-events-auto;
  width:120vw;height:120vw;
  transform:translate(-50%, -120px);
  top:100%;left:50%;
  width:120vmax;height:120vmax;
  transform:translate(-50%, -12vmax);
  transform:translate(-50%, -15vmax);

  @apply transition duration-700 ease-in-out;

  @screen md {
    width:120vmax;height:120vmax;
    transform:translate(-50%, -8vmax);
  }

  &.hide {
    transform:translate(-50%, 0);
    @screen md {
      transform:translate(-50%, 0);
    }
  }
  // width:200vw;height:200vw;top:100%;left:50%;transform:translate(-50%, 0px);
  // @apply fixed pointer-events-auto top-0;
  // width:50vw;height:50vw;top:20%;left:50%;transform:translate(-50%, 0px);
  // border: 5px solid yellow;
}

.track-complete {
  @apply absolute inset-0 w-1/2 h-full overflow-hidden;
  .track-complete-stroke {
    width: 200%;
    @apply absolute inset-0;
    @apply border-2 border-white rounded-full z-10;
  }
}

.track-marking {
  @apply absolute;
  top:0%;left:50%;transform:translate(-50%, -40%);
  @apply border border-white;
  width: 0px;
  height: 8px;
}

.track {
  @apply absolute inset-0;
  @apply border border-white border-opacity-50 rounded-full fixed z-10;

  .track-cell {
    @apply absolute transform-gpu -translate-x-1/2 -translate-y-0 top-0 left-1/2;
    // @apply border border-red-400;
    width: 0px;
    height: 100%;

    .track-content {
      @apply absolute transform-gpu -translate-x-1/2 -translate-y-0 top-0 left-1/2;

      .marker {
        @apply absolute transform-gpu -translate-x-1/2 -translate-y-1/2 left-1/2 top-0;
        @apply rounded-full border border-white border-opacity-50 text-center w-5 h-5 text-xs bg-black text-white;
        @apply transition duration-300;
        line-height:1.5;
      }
      .title-intro {
        @apply absolute transform-gpu -translate-x-1/2 left-1/2 top-4;
      }
      .title {
        // @apply absolute transform-gpu -translate-x-1/2 left-1/2 top-4;
        // @apply transform-gpu -translate-y-1/2;
        @apply text-center text-xs text-white text-opacity-50 whitespace-nowrap;
        @apply transition duration-300;
        @apply mb-4;
      }
      .intro {
        // @apply absolute transform-gpu -translate-x-1/2 left-1/2 top-4;
        @apply transform-gpu translate-y-1/2;
        @apply text-center text-xs text-white;
        @apply transition duration-300;
        @apply text-opacity-0 pointer-events-none;
        @apply w-80 max-w-xl;
      }
    }

    &.active {
      .marker {
        @apply bg-white text-black text-opacity-50 border-opacity-100;
      }
      .title {
        @apply scale-105 text-opacity-75;
      }
      .intro {
        @apply text-opacity-0;
      }
    }
    &.active-snap {
      .marker {
        @apply scale-125 text-opacity-100 border-opacity-100;
        // @apply w-7 h-7 text-sm;
        // line-height:1.75;
      }
      .intro-title {
        @apply scale-105;
      }
      .title {
        @apply -translate-y-0;
        @apply text-opacity-100;
      }
      .intro {
        @apply -translate-y-0;
        @apply text-opacity-100;
      }
    }
  }
}

.flickity-wrapper {
  @apply absolute top-0 inset-x-0 z-20 h-full;
  height: 100%;

  .flickity-track {
    @apply w-full h-full;
  }
  .flickity-cell {
    // @apply border border-red-500;
    @apply h-full;
    min-width: 150px;
    margin-right: 10vw;
    @screen lg {
      margin-right: 400px;
    }
  }
}
</style>
